import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GATrackingEventType,
  GaTrackingEventCategory,
  GaTrackingEventName,
  GaTrackingStringConstantEnum,
  offerTypes,
} from '../../constants';
import { Product } from '~shared/models';
import get from 'lodash.get';
import { Category } from '~app/modules/generic/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export class GaTrackingSelectRecommendationEvent implements GATrackingEvent {
  constructor(private products: Product, private index: number, private priceType?: PriceTypes) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SelectRecommendation;
  }

  getPayload(): GATrackingEventPayload {
    const productPromoViewTracking = {
      category: GaTrackingEventCategory.Ecommerce,
      ecommerce: {
        items: {
          item_name: get(this.products, 'name'),
          item_id: get(this.products, 'id'),
          price:
            this.priceType === PriceTypes.b2b
              ? get(this.products, 'bestOffer.price.netPrice', 0)
              : get(this.products, 'bestOffer.price.grossPrice', 0),
          item_brand: this.products?.attributes?.brand?.name,
          ...([...this.products?.categories].reverse() as any)?.reduce(
            (categories: {}, category: Category, categoryIndex: number) => {
              if (categoryIndex === 0) {
                categories['item_category'] = category.name;
              } else {
                categories[`item_category${categoryIndex + 1}`] = category.name;
              }
              return categories;
            },
            {}
          ),
          item_list_name: GaTrackingStringConstantEnum.Carousel,
          item_promo: this.products?.hasPromotion ? GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No,
          item_strikethrough: this.products?.bestOffer?.referencePrice?.priceType,
          item_energy_label: this.products?.attributes?.energyEfficiencyClass,
          item_volume_pricing: !!this.products?.bestOffer?.volumePrice?.length
            ? GaTrackingStringConstantEnum.Yes
            : GaTrackingStringConstantEnum.No,
          item_other_offers: GaTrackingStringConstantEnum.No,
          item_offer_type: offerTypes.cheapest,
          item_discount_rate: this.products?.bestOffer?.referencePrice?.discountPercentage,
          index: this.index,
        },
      },
    };

    return {
      event: GaTrackingEventName.SelectRecommendation,
      gtmCustom: productPromoViewTracking,
    };
  }
}
